import { defineAction } from '~/prix'
import { z } from 'zod'
import heavyMachineryCreateAction from './heavyMachineryCreate.action.json' with { type: 'json' }
import { heavyMachineryCreateInputObject } from '../heavyMachineryObject'

const heavyMachineryCreateDefinition = defineAction({
  ...heavyMachineryCreateAction,

  input: heavyMachineryCreateInputObject,
  output: z.object({
    id: z.string().uuid(),
    code: z.number().int().positive(),
  }),
})

export default heavyMachineryCreateDefinition
